module.exports = __webpack_public_path__ + "static/media/fla.0bd34dea.svg";